import { Field, Form as FormikForm, Formik } from 'formik';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import React, { useState, useRef, useEffect } from 'react';
import StaticModal from '../modal/staticModal';
import { Button, Spinner } from 'react-bootstrap';
import Loader from '../loader';
// import '../styles.css';
import './style.css';

type Props = {
  isCouponPopupDisplayed: boolean;
  isPanVerficationRequired?: boolean;
  couponList: any;
  onKYCPopupClose?: () => void;
  closeModal?: () => void;
  hideModal?: () => void;
  onCouponApply?: (data) => void;
  onResetCoupon?: () => void;
  childFunc: any;
};

const CouponModal = React.forwardRef(
  ({
    isCouponPopupDisplayed,
    isPanVerficationRequired,
    onKYCPopupClose,
    closeModal,
    hideModal,
    couponList,
    onCouponApply,
    childFunc,
  }: Props) => {
    const [loading, setLoading] = useState(false);
    const [selectedCoupon, setSelectedCoupon] = useState('');
    const [couponListData, setCouponListData] = useState([]);
    // const [couponName, setCouponName] = useState('');
    const [inputCouponName, setInputCouponName] = useState('');

    useEffect(() => {
      setLoading(true);
      const loadingTimeout = setTimeout(() => {
        if (couponList && couponList?.data && couponList?.data?.data) {
          setCouponListData(couponList?.data?.data);
        } else {
          setCouponListData([]);
        }
        setLoading(false);
      }, 5000); 

      return () => clearTimeout(loadingTimeout);
    }, [couponList]);


    const onSelectCoupon = (value) => {
      setSelectedCoupon(value);
      // setCouponName(value.name);
      setInputCouponName(value.name);
    };

    const onApplyCoupon = () => {
      if (selectedCoupon?.length > 0) {
        onCouponApply(selectedCoupon);
      }
      else {
        onCouponApply(inputCouponName);
      }


    };

    React.useEffect(() => {
      childFunc.current = onResetCoupon;
    }, []);

    const onResetCoupon = () => {
      // setSelectedCoupon('');
      // setCouponName('');
      setInputCouponName('');
    };

    const handleChange = (e) => {
      setInputCouponName(e.target.value.toUpperCase());
    };

    // const filteredData = couponListData?.filter((el) => {
    //   if (inputCouponName === '') {
    //     return el;
    //   } else {
    //     return (
    //       el.name.toLowerCase().includes(inputCouponName) ||
    //       el.name.toUpperCase().includes(inputCouponName)
    //     );
    //   }
    // });

    return (
      <>
        <StaticModal
          show={isCouponPopupDisplayed}
          handleClose={onKYCPopupClose}
          title='Select coupon'
          onClose={() => {
            hideModal(), onResetCoupon();
          }}

        // size='lg'
        >
          <Formik
            // innerRef={ref}
            initialValues={{}}
            onSubmit={null}
          >
            {({ }) => (
              <FormikForm>
                <div className='coupon-div'>
                  <InputGroup className='mb-3'>
                    <Form.Control
                      placeholder='Enter coupon code'
                      aria-label="Recipient's username"
                      aria-describedby='basic-addon2'
                      value={inputCouponName}
                      onChange={(e) => handleChange(e)}
                    // disabled={true}
                    />
                    {/* <Button
                      onClick={() => onApplyCoupon()}
                      variant='primary'
                      id='button-addon2'
                    >
                      Apply coupon
                    </Button> */}
                    <button
                      className='btn btn-verify'
                      id='button-pan'
                      type='button'
                      onClick={() => onApplyCoupon()}
                      disabled={inputCouponName === '' ? true : false}
                    >
                      Apply coupon
                    </button>
                  </InputGroup>
                </div>
              </FormikForm>
            )}
          </Formik>

            <div className='available-coupon'>
            {loading ? (
              <div className='loader-container' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Spinner animation='border' role='status' />
              </div>
            ) : (
              <>
                {couponListData?.length > 0 ? (
                  couponListData?.map((value) => (
                    <div className='inner-coupon-div' key={value.id}>
                      <Form.Check
                        type='radio'
                        label={value?.name}
                        name='payment-group'
                        className='copon-radio'
                        onClick={() => onSelectCoupon(value)}
                      />
                      <span className='coupon-des'>{value?.description}</span>
                    </div>
                  ))
                ) : (
                  <div style={{justifyContent:'center', textAlign:'center'}}>No coupons at this moment</div>
                )}
              </>
            )}
          </div>

        </StaticModal>
      </>
    );
  }
);

export default React.memo(CouponModal);
